import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import AuthContext from "../../context/userAuth.context";
import Popup from "reactjs-popup";
import TemplateItem from "../dashboard.rightarea.component/dashboard.templateItem.component";
import CharacterContext from "../../context/CharacterContext";
import { useHistory } from "react-router";
import Lottie from "react-lottie";
import load from "../../assets/Loader/AssetLoader.json";
import Swal from "sweetalert";
import Swal2 from "sweetalert2";
//import 'animate.css';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Crop32Icon from "@mui/icons-material/Crop32";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import CropPortraitIcon from "@mui/icons-material/CropPortrait";
import Tooltip from "@mui/material/Tooltip";
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import TextField from "@mui/material/TextField";
import Button from '@mui/material/Button';
import Box from "@mui/material/Box";
import UpdateTags from "../../Search/UpdateTags";
import { CONVERT_KEY, RATIOS } from "../../Utils/convertCanvas";

const SIZE_LABELS = { "16:9": "Standard 16:9", "9:16": "Mobile 9:16", "1:1": "Square 1:1" };

/** Newest templates first (agency templates stay on top for agency users). Id = order added. */
const newestFirst = (list) =>
  Array.isArray(list)
    ? list.slice().sort((a, b) => (Number(!!b.isAgencyTemplate) - Number(!!a.isAgencyTemplate)) || (Number(b.id) || 0) - (Number(a.id) || 0))
    : list;

export const Templates = () => {
  const [popupload, setpopupload] = useState(false);

  const closeModal = () => {
    setpopupload(false);
  };

  const {
    categoriesProject,
    setcategoriesProject,
    authenticationData,
    Access,
    getLink,
    Role
  } = useContext(AuthContext);

  const { Categories } = useContext(CharacterContext);
  const [tempTemplates, settempTemplates] = useState([]);
  const [size, setSize] = useState("All");

  useEffect(() => {
    getAllTemplates();
  }, []);

  // useEffect(() => {
  //     getAllTemplates();
  // }, [size])

  const [showDiv, setshowDiv] = useState({ name: "All Templates", id: null });

  const handlechange = (e) => {
    if (e.key === "Enter") {
      if (e.target.value === "") {
        setshowDiv("All Templates");
      } else {
        setshowDiv(e.target.value);
      }
    }
  };

  const catRef = useRef(null);

  const [FiltCategory, setFiltCategory] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [open, setOpen] = useState(false);
  const [itemId, setItemId] = useState(0);
  const ObjectTags = (photos) => {
    console.log('photos', photos.target.id)
    setOpen(true);
    setItemId(photos.target.id);
  };
  useEffect(() => {
    if (showDiv != "All Templates") {
      let DataArray = [];
      var filterProjects;
      if (size != "All") {
        filterProjects = categoriesProject.filter((x) => x.canvasSize == size);
      } else {
        filterProjects = categoriesProject;
      }

      for (let i = 0; i < filterProjects.length; i++) {
        let data = JSON.parse(filterProjects[i].categoryIds);
        if (data) {
          for (let j = 0; j < data.length; j++) {
            if (data[j] == showDiv.id) {
              DataArray.push(filterProjects[i]);
            }
          }
        }
      }
      setFiltCategory(DataArray);
    }
  }, [showDiv]);

  const FilterTemplate = (catID) => {
    let DataArray = [];
    var filt = [];
    if (size != "All") {
      filt = categoriesProject.filter((x) => x.canvasSize == size);
    } else {
      filt = categoriesProject;
    }
    if (catID) {
      for (let i = 0; i < filt.length; i++) {
        let data = JSON.parse(filt[i].categoryIds);
        if (data) {
          for (let j = 0; j < data.length; j++) {
            if (data[j] == catID) {
              DataArray.push(filt[i]);
            }
          }
        }
      }
      settempTemplates(DataArray);
    } else {
      settempTemplates(filt);
    }
  };

  const FilterTemplateBySize = (size, catID) => {
    let DataArray = [];
    var filt = [];
    if (size != "All") {
      filt = categoriesProject.filter((x) => x.canvasSize == size);
    } else {
      filt = categoriesProject;
    }
    if (catID && catID != "All") {
      for (let i = 0; i < filt.length; i++) {
        let data = JSON.parse(filt[i].categoryIds);
        if (data) {
          for (let j = 0; j < data.length; j++) {
            if (data[j] == catID) {
              DataArray.push(filt[i]);
            }
          }
        }
      }
      settempTemplates(DataArray);
    } else {
      settempTemplates(filt);
    }
  };

  let history = useHistory();

  const [CurrentSelect, setCurrentSelect] = useState(null);

  const [Loader, setLoader] = useState(true);

  useEffect(() => {
    if (categoriesProject.length != 0) {
      setLoader(false);
    }
  }, [categoriesProject]);

  useEffect(() => {
    if (popupload) {
      getUserTemplate();
    }
  }, [popupload]);

  const getAllTemplates = () => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    axios
      .get(
        authenticationData.ApiBaseURL +
        "/api/Category/GetAllTemplates?size=All",
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          const list = newestFirst(response.data.result);
          setcategoriesProject(list);
          settempTemplates(list);
        }
      })
      .catch((error) => { });
  };

  const getUserTemplate = () => {
    // The template opens in the editor in its own size, or converted to another one.
    const own = RATIOS[CurrentSelect && CurrentSelect.canvasSize] ? CurrentSelect.canvasSize : "16:9";
    const inputOptions = {};
    ["16:9", "9:16", "1:1"].forEach((k) => {
      inputOptions[k] = SIZE_LABELS[k] + (k === own ? " (original)" : "");
    });
    Swal2.fire({
      title: "Open this template?",
      text: "It opens in the editor. Choose the video size; another size converts every scene.",
      icon: "info",
      input: "radio",
      inputOptions,
      inputValue: own,
      showCancelButton: true,
      confirmButtonText: "Open in editor",
      confirmButtonColor: "#296AFF",
      customClass: { popup: "tpl-open" },
    }).then((result) => {
      const value = result && result.isConfirmed;
      if (value) {
        try {
          if (result.value && result.value !== own) sessionStorage.setItem(CONVERT_KEY, result.value);
          else sessionStorage.removeItem(CONVERT_KEY);
        } catch (e) {
          /* opens in its own size */
        }
        localStorage.removeItem("CurrentChooseProject");
        sessionStorage.removeItem("CurrentChooseProjectId");
        sessionStorage.setItem("CurrentChooseProjectId", CurrentSelect.id);
        history.push("/editor");

        let authData = JSON.parse(
          localStorage.getItem("animation_studio_2.0_access_token")
        );
      } else {
        setpopupload(false);
      }
    });
  };


  async function handleSearch() {

    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );
    let formdata = new FormData();
    formdata.append("keyword", keyword);
    axios
      .post(
        authenticationData.ApiBaseURL +
          "/api/Administration/getTemplatesBykeyword",
        formdata,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
          // if (response.data.status) {
          // setcategoriesProject(response.data.response);
          settempTemplates(newestFirst(response.data.response));
        // }
        console.log('response', response.data.response)
        console.log('tempTemplates', tempTemplates)
      });
  }
  const popfunction = (value) => {
    if (Access == "FE" && value.isPremium) {
      Swal2.fire({
        title: "Upgrade Required",
        html: `You have not purchased this upgrade yet. Please <a href=${getLink()} target='_blank'>upgrade</a> to unlock all features.`,
        icon: "info",
        cancelButtonColor: "#d33",
        backdrop: null,
      });
    } else {
      setpopupload(true);
      setCurrentSelect(value);
    }
  };

  const [activeCategory, setactiveCategory] = useState("");
  const [activeCategoryName, setactiveCategoryName] = useState("All");
  const [SlideAnimation, setSlideAnimation] = useState("");
  const [hoverItem, sethoverItem] = useState();
  return (
    <>
      <div className="temp1">
        <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end", // Align items to the right side
              textAlign: "center",
              width: "100%", // Ensure the box takes full width
            }}
        >
          <TextField
            id="search-bar"
            className="text"
            value={keyword}
            onChange={(e) => {
              setKeyword(e.target.value);
            }}
            variant="outlined"
            placeholder="What are you looking for?"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button style={{ marginLeft: '10px' }} onClick={handleSearch} variant="contained">Search</Button>
        </Box>
        <div className="temp2">
          <div
            onClick={() => {
              setSlideAnimation(" animate__slideInLeft");
              catRef.current.scrollLeft = catRef.current.scrollLeft - 800;
            }}
            className="category-scroller-left"
          >
            <span className="material-icons">arrow_back_ios</span>
          </div>
          <div className="tempScroll" ref={catRef}>
            <div className="tempInner">
              <div
                className={
                  "TempDiv2 TempDiv1 " +
                  (activeCategory == ""
                    ? "tempDivActive"
                    : activeCategory == "All"
                      ? "tempDivActive"
                      : "")
                }
                // onClick={() => setshowDiv({ name: "All Templates", id: null })}
                onClick={() => {
                  FilterTemplate(null);
                  setactiveCategory("All");
                  setactiveCategoryName("All");
                }}
              >
                <img
                  alt=""
                  className={
                    "mr-3 TempImgSize " +
                    (activeCategory == ""
                      ? "ActiveImg"
                      : activeCategory == "All"
                        ? "ActiveImg"
                        : "")
                  }
                  src={
                    authenticationData.ApiBaseURL +
                    "/" +
                    "Assets/TemplatesCategories/All.png"
                  }
                />
                <span>All Templates</span>
              </div>
              {Categories.length != 0 &&
                Categories.map((lmc, index) => (
                  <div
                    key={index.toString()}
                    className={
                      "TempDiv2 TempDiv1 " +
                      (activeCategory == lmc.id ? "tempDivActive" : "") +
                      SlideAnimation
                    }
                    // onClick={() => setshowDiv({ name: lmc.name, id: lmc.id })}
                    onClick={() => {
                      FilterTemplate(lmc.id);
                      setactiveCategory(lmc.id);
                      setactiveCategoryName(lmc.name);
                    }}
                  >
                    <img
                      alt=""
                      //   className="mr-3 TempImgSize"
                      className={
                        "mr-3 TempImgSize " +
                        (activeCategory == lmc.id ? "ActiveImg" : "") +
                        SlideAnimation
                      }
                      src={authenticationData.ApiBaseURL + "/" + lmc.image}
                    />
                    <span>{lmc.name}</span>
                  </div>
                ))}
            </div>
          </div>
          <div
            onClick={() => {
              setSlideAnimation(" animate__slideInLeft");
              catRef.current.scrollLeft = catRef.current.scrollLeft + 800;
            }}
            className="category-scroller-left category-scroller-right-padding"
          >
            <span className="material-icons">arrow_forward_ios</span>
          </div>
        </div>
        <div className="flex-row mt-5 mb-3 justify-spaced">
          <div>
            Showing results for: <strong>{activeCategoryName}</strong>
          </div>
          <div className="flex-row" style={{ gap: "16px" }}>
            <label>Filter by size:</label>
            <div className="flex-row" style={{ gap: "12px" }}></div>
            <Tooltip title="All Sizes" arrow>
              <div
                className={
                  "filter-size-icon " + (size == "All" ? "filterActive" : "")
                }
                onClick={() => {
                  setSize("All");
                  if (activeCategory != "") {
                    FilterTemplateBySize("All", activeCategory);
                  } else {
                    FilterTemplateBySize("All", null);
                  }
                }}
              >
                <label>All</label>
              </div>
            </Tooltip>
            <Tooltip title="Standard (16:9)" arrow>
              <div
                className={
                  "filter-size-icon " + (size == "16:9" ? "filterActive" : "")
                }
                onClick={() => {
                  setSize("16:9");
                  if (activeCategory != "") {
                    FilterTemplateBySize("16:9", activeCategory);
                  } else {
                    FilterTemplateBySize("16:9", null);
                  }
                }}
              >
                <Crop32Icon sx={{ fontSize: 24 }}></Crop32Icon>
              </div>
            </Tooltip>
            <Tooltip title="Mobile (9:16)" arrow>
              <div
                className={
                  "filter-size-icon " + (size == "9:16" ? "filterActive" : "")
                }
                onClick={() => {
                  setSize("9:16");
                  if (activeCategory != "") {
                    FilterTemplateBySize("9:16", activeCategory);
                  } else {
                    FilterTemplateBySize("9:16", null);
                  }
                }}
              >
                <CropPortraitIcon sx={{ fontSize: 24 }}></CropPortraitIcon>
              </div>
            </Tooltip>
            <Tooltip title="Square (1:1)" arrow>
              <div
                className={
                  "filter-size-icon " + (size == "1:1" ? "filterActive" : "")
                }
                onClick={() => {
                  setSize("1:1");
                  if (activeCategory != "") {
                    FilterTemplateBySize("1:1", activeCategory);
                  } else {
                    FilterTemplateBySize("1:1", null);
                  }
                }}
              >
                <CropSquareIcon sx={{ fontSize: 24 }}></CropSquareIcon>
              </div>
            </Tooltip>
          </div>
        </div>


      </div>
      <div className="gridViewTemplates mt-3">
        {tempTemplates.length > 0 &&
          tempTemplates.map((value, index) => {
            var w = value.canvasSize.split(":")[0];
            var h = value.canvasSize.split(":")[1];
            let ratio = w / h;
            let padding = (h / w) * 100 + "%";
            return (
              <React.Fragment key={index}>
                <div>
                  
                <div
                 
                  //   onMouseOver={() => {
                  //     sethoverItem(true);
                  //   }}
                  //   onMouseLeave={() => {
                  //     sethoverItem(false);
                  //   }}
                  class="captionWrapper___15cOi item___3380i bottomIndentSmall___3TgBx"
                  style={{ width: 184 * ratio, flexGrow: ratio * 10 }}
                  href="#"
                >
                      {Role == "admin" && (
                      <span
                        id={value.id}
                        onClick={(e) => ObjectTags(e)}
                        className="material-icons"
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "0px",
                          color: "#9f9393",
                          zIndex: "999",
                        }}
                      >
                        edit
                      </span>
                    )}
                  <div
                   onClick={(e) => popfunction(value)}
                    class={
                      hoverItem
                        ? "cardCust preview___2p4uz imgWrapper___1dRUW imgWrapper___20yEp translateItem"
                        : "cardCust preview___2p4uz imgWrapper___1dRUW imgWrapper___20yEp"
                    }
                    style={{ paddingBottom: padding, position: "relative" }}
                  >
                    {Access == "FE" && value.isPremium ? (
                      <img
                        className="premiumIcon"
                        style={{
                          top: "7px",
                          right: "7px",
                          width: "32px",
                        }}
                        src="../AppIcons/IconsAll/PremiumIcon.svg"
                        alt=""
                      />
                    ) : null}

                    <img
                      alt=""
                      loading="lazy"
                      src={
                        value.previewImagePath != null &&
                          value.previewImagePath != ""
                          ? authenticationData.ApiBaseURL +
                          "/" +
                          value.previewImagePath
                          : authenticationData.ApiBaseURL +
                          "/" +
                          "images/DefaultProject.png"
                      }
                      class="itemImg___1GRZk templatesSearchResults"
                    />
                  
                  </div>
                  <div class="caption___14hDw proxima-semibold___1HNzk proxima-s___29loE">
                    <div class="title___3aJ-x"> {value.projectName}</div>
                    <div class="subTitle___2DmoO2">{value.canvasSize}</div>
                  </div>
                </div>
                </div>
               
              </React.Fragment>
            );
          })}
            {open === true && (
                  <UpdateTags
                    itemId={itemId}
                    type={"Templates"}
                    open={open}
                    setOpen={setOpen}
                  />
                )}
      </div>
    </>
  );
};

export default Templates;
